export const AUDIENCE = process.env.NEXT_PUBLIC_AUTH0_AUDIENCE;
export const CLIENT_ID = process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID;
export const CONNECTION = process.env.NEXT_PUBLIC_AUTH0_CONNECTION;
export const DOMAIN = process.env.NEXT_PUBLIC_AUTH0_DOMAIN;
